<template>
  <div>
    <multiselect-ajax
        :key="`${_uid}-sale-orders`"
        :name="name || 'sale_order_id'"
        :placeholder="placeholder || $t('Select {something}', { something: $t('sale_notes.singular') })"
        :value="value"
        @input="(v) => onInput(v)"
        @update:selected="$emit('update:selected', $event)"
        :custom-label="customLabel"
        :required="required"
        :disabled="disabled"
        :url="`/sale_orders`"
        :params="{ ...params }"
        :open-direction="openDirection"
        :multiple="multiple"
        :include-null-value="includeNullValue"
        :search-key="searchKey"
    >
      <template v-slot:option="{ option }">
        <slot name="option" v-bind="{ option }"></slot>
      </template>
    </multiselect-ajax>
  </div>
</template>

<script>
import MultiselectAjax from "../vue-multiselect-ajax";

export default {
  name: "sale-order-multiselect-ajax",
  components: {
    MultiselectAjax,
  },
  props: {
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    value: {
      type: [Array, String],
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    customLabel: {
      type: Function,
      default(value) {
        if(value.id === 'not available') {
          return this.lodash.startCase(this.$t('not available'));
        }
        return value.id
      }
    },
    openDirection: {
      type: String,
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    includeNullValue: {
      type: Boolean,
      default: false,
    },
    searchKey: {
      type: String,
      default: 'search',
    },
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
